module.exports = __webpack_public_path__ + "static/img/bonus_8.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_8.png
// module id = /IWD
// module chunks = 0